import { defineMessages } from 'react-intl'

export default defineMessages({
    open24: {
        defaultMessage: 'Abierto 24h',
    },
    carChargePoint: {
        defaultMessage: 'Cargador eléctrico',
    },
    disabledAccess: {
        defaultMessage: 'Parking accesible',
    },
    car: {
        defaultMessage: 'Coche',
    },
    truck: {
        defaultMessage: 'Camión',
    },
    motorcycle: {
        defaultMessage: 'Moto',
    },
    vans: {
        defaultMessage: 'Furgoneta',
    },
    caravans: {
        defaultMessage: 'Caravana',
    },
    bus: {
        defaultMessage: 'Autobús',
    },
    bicycle: {
        defaultMessage: 'Bicicleta',
    },
    airportTransfer: {
        defaultMessage: 'Traslado a terminal',
    },
    pickUp: {
        defaultMessage: 'Valet',
    },
    walking: {
        defaultMessage: 'Traslado a pie',
    },
    onlyAena: {
        defaultMessage: 'Mostrar solo AENA',
    },
    oficialParkings: {
        defaultMessage: 'Parkings oficiales de AENA',
    },
    vehicleType: {
        defaultMessage: 'Tipo de vehículo',
    },
    serviceParkings: {
        defaultMessage: 'Servicios del parking',
    },
    moreFilters: {
        defaultMessage: 'Más Filtros',
    },
    serviceAirportParkings: {
        defaultMessage: 'Servicios para parking de aeropuertos',
    },
    applyFilters: {
        defaultMessage: 'Aplicar filtros',
    },
    cancel: {
        defaultMessage: 'Cancelar',
    },
})
